const Footer = () => {
    const accordions = document.querySelectorAll(".js-accordion");

    if (accordions.length) {
        accordions.forEach((accordion) => {
            // footer accordions are expanded by default (accessible without javascript)
            accordion.classList.remove("c-footer__link-block--open");
            const trigger = accordion.querySelector(".c-footer-toggle");
            const dropdown = accordion.querySelector(".c-footer__dropdown");
            const icon = accordion.querySelector(".c-footer__link-icon");
            trigger.setAttribute("aria-expanded", false);
            icon.innerHTML = "+";

            let isActive = accordion.getAttribute("aria-expanded") === "true";

            trigger.addEventListener("click", () => {
                if (!isActive) {
                    isActive = true;
                    accordion.classList.add("c-footer__link-block--open");
                    trigger.setAttribute("aria-expanded", "true");
                    dropdown.removeAttribute("hidden");
                    icon.innerHTML = "-";
                } else {
                    isActive = false;
                    accordion.classList.remove("c-footer__link-block--open");
                    trigger.setAttribute("aria-expanded", "false");
                    dropdown.setAttribute("hidden", "");
                    icon.innerHTML = "+";
                }
            });
        });
    }
};

export default Footer;
